/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateApologyRequestDTO
 */
export interface CreateApologyRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateApologyRequestDTO
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof CreateApologyRequestDTO
     */
    action: CreateApologyRequestDTOActionEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateApologyRequestDTOActionEnum {
    Save = 'SAVE',
    Start = 'START',
    Stop = 'STOP'
}

export function CreateApologyRequestDTOFromJSON(json: any): CreateApologyRequestDTO {
    return CreateApologyRequestDTOFromJSONTyped(json, false);
}

export function CreateApologyRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApologyRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': json['days'],
        'action': json['action'],
    };
}

export function CreateApologyRequestDTOToJSON(value?: CreateApologyRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': value.days,
        'action': value.action,
    };
}

